import { render, staticRenderFns } from "./NewLibrariesVersion.vue?vue&type=template&id=34a0e820"
import script from "./NewLibrariesVersion.vue?vue&type=script&lang=js"
export * from "./NewLibrariesVersion.vue?vue&type=script&lang=js"
import style0 from "./NewLibrariesVersion.vue?vue&type=style&index=0&id=34a0e820&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports